import type { WhitelabelTemplateValue } from "@src/config/featureFlags"

export const domains: Record<string, WhitelabelTemplateValue> = {
  "near-intents.org": "near-intents",
  "solswap.org": "solswap",
  "dogecoinswap.org": "dogecoinswap",
  "turboswap.org": "turboswap",
  "trump-swap.org": "trumpswap",
}
